import { render, staticRenderFns } from "./HeaderSearchCategory.vue?vue&type=template&id=24e2fcb6&scoped=true"
import script from "./HeaderSearchCategory.vue?vue&type=script&lang=js"
export * from "./HeaderSearchCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e2fcb6",
  null
  
)

export default component.exports